import Index from './page/index'

export default [
  {
    path: '/transactions-pix',
    name: 'transactions-pix-index',
    component: Index
  }
]
